export enum CallingProductId {
    None = 0,
    Total = 1
}
